import { render, staticRenderFns } from "./TypeRingChart.vue?vue&type=template&id=90159a58&scoped=true"
import script from "./TypeRingChart.vue?vue&type=script&lang=js"
export * from "./TypeRingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90159a58",
  null
  
)

export default component.exports